import React from 'react'
import '../courses.css'
import Menubar from '../../home/menubar/Menubar'
import Address from '../../home/footer/Address'
import Carousel from '../../home/carousel/Carousel'
import { cImg, cData, c_gif } from '../../home/data'
import Hower from '../../home/hower/Hower'
import Typewriter from '../../home/lazy loader/Typewriter'
import ScrollToTopProgress from '../../home/header/ScrollToTopProgress'
import Header from '../../home/header/Header'

function Clanguage() {
  const imgUrl = cImg;
  const txt = cData;
  const gif = c_gif;
  return (
    <div>
        <Header/>
        <Menubar/>
        <Carousel imgUrl={imgUrl}/>
        <Hower gif={gif}/>
        <Typewriter txt={txt}/>

        
        <div className='pannel-container'>
          <div className="accordion accordion-flush" id="accordionFlushExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingOne">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
        <p className='panel-title'>C-Language Level-1</p>
      </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
            <li className='list'>What is C ?</li>
            <li className='list'>C Flow Control</li>
            <li className='list'>C Functions</li>
            <li className='list'>C Programming Arrays</li>
            <li className='list'>C Programming Pointers</li>
            <li className='list'>C Programming Strings</li>
            <li className='list'>Structure And Union</li>
            <li className='list'>C Programming Files</li>
            <li className='list'>C Programming Examples</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
        <p className='panel-title'>C-Language Level-2</p>
      </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          	<li className='list'>What is C-Language ?</li>
            <li className='list'>Basics of - C </li>
            <li className='list'>Data Types</li>
            <li className='list'>Storage Classes</li>
            <li className='list'>Input/Output</li>
            <li className='list'>Operators</li>
            <li className='list'>Preprocessor</li>
            <li className='list'>Arrays & Strings</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingThree">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
        <p className='panel-title'>C-Language Level-3</p>
      </button>
    </h2>
    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>Control Statements</li>
          <li className='list'>Functions</li>
          <li className='list'>Pointers</li>
          <li className='list'>Enum, Struct and Union</li>
          <li className='list'>Memory Management</li>
          <li className='list'>File Handling</li>
          <li className='list'>Puzzles</li>
          <li className='list'>Misc</li>
        </ul>
      </div>
    </div>
  </div>
          </div>
        </div>

<div className="table-header">
	<h4><u><b>COURSE DETAILS :</b></u></h4>
	<table className="table">
    <thead>
		<tr>
		<th colSpan="2" className="heading">C-language</th>
		</tr>
    </thead>
    <tbody>
<tr>
	<td>Procedural Language </td>
	<td>Instructions in a C program are executed step by step.</td>
</tr>
<tr>
	<td>Portable </td>
	<td>You can move C programs from one platform to another, and run it without any or minimal changes.</td>
</tr>
<tr>
	<td>Speed </td>
	<td>C programming is faster than most programming languages like Java, Python, etc.</td>
</tr>
<tr>
	<td>General Purpose  </td>
	<td>C programming can be used to develop operating systems, embedded systems, databases, and so on.</td>
</tr>
</tbody>
  </table>
</div>
        <Address/>
        <ScrollToTopProgress/>
    </div>
  )
}

export default Clanguage